import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { style: {"font-weight":"bold","margin":"0"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, " At the selected place, these products are currently available (scan to take): ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, " While creating this document, you placed these products at the scanned place: ", -1)

import { IonText, IonList, } from '@ionic/vue';
import ArticleQuantityCardBase from '@components/article/ArticleQuantityCardBase.vue';
import MovePlacementsManual from './MovePlacementsManual.vue'
import useMovePlacementsActionStore from '@/store/movePlacementsAction';
import { storeToRefs } from 'pinia';
import { IAggregatedPlacementCompact } from '@/const/types/placement';

interface Props {
  mode: "take" | "put";
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MovePlacementsSelectedPlaceArticlesList',
  props: {
    mode: null
  },
  setup(__props: any) {

const props = __props as {
  mode: "take" | "put";
};



const movePlacementsActionStore = useMovePlacementsActionStore()
const { selectedPlace } = storeToRefs(movePlacementsActionStore)

const getRemainingQuantity = (placement: IAggregatedPlacementCompact) => (
  movePlacementsActionStore.getRemainingArticleQuantityForPlace(placement)
)


return (_ctx: any,_cache: any) => {
  return (!_unref(selectedPlace))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonText), null, {
          default: _withCtx(() => [
            _createTextVNode("Place is not selected. Start action by scaning place.")
          ]),
          _: 1
        }),
        _hoisted_2,
        _withDirectives(_createVNode(MovePlacementsManual, null, null, 512), [
          [_vShow, props.mode == 'take']
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_unref(IonText), null, {
          default: _withCtx(() => [
            _createTextVNode(" Selected place (scan to change):"),
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(selectedPlace).name), 1),
        (props.mode == 'take')
          ? (_openBlock(), _createBlock(_unref(IonList), { key: 0 }, {
              default: _withCtx(() => [
                _hoisted_6,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(movePlacementsActionStore).placeCompactTakePlacements(), (article) => {
                  return _withDirectives((_openBlock(), _createBlock(ArticleQuantityCardBase, {
                    key: article.document_product_id,
                    article: article
                  }, {
                    right: _withCtx(() => [
                      _createTextVNode(_toDisplayString(getRemainingQuantity(article)) + " szt. ", 1)
                    ]),
                    _: 2
                  }, 1032, ["article"])), [
                    [_vShow, getRemainingQuantity(article) > 0]
                  ])
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (props.mode == 'put')
          ? (_openBlock(), _createBlock(_unref(IonList), { key: 1 }, {
              default: _withCtx(() => [
                _hoisted_7,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(movePlacementsActionStore).placeCompactPutPlacements(), (article) => {
                  return _withDirectives((_openBlock(), _createBlock(ArticleQuantityCardBase, {
                    key: article.document_product_id,
                    article: article
                  }, {
                    right: _withCtx(() => [
                      _createTextVNode(_toDisplayString(article.quantity) + " szt. ", 1)
                    ]),
                    _: 2
                  }, 1032, ["article"])), [
                    [_vShow, article.quantity > 0]
                  ])
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]))
}
}

})